import { PhoneNumbersService } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-numbers/phone_numbers_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaCallBlockV1Service = bindHTTP(PhoneNumbersService);
export const serviceName = 'call-block-v1' as const;
